module.exports = __webpack_public_path__ + "static/media/touch1.0c71904a.png";